import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {API_URLS} from '../config';
import {ContractData} from '../interfaces/contract-data';
import {catchError} from 'rxjs/operators';
import {CommonResponse} from '../interfaces/common-response';
import {SupportRequestArgs} from '../interfaces/support-request-args';

@Injectable({
  providedIn: 'root'
})

export class DashboardService {


  constructor(private http: HttpClient) {
  }

  logout(): Observable<void> {
    return this.http.get<void>(API_URLS.logout);
  }

  getContractData(): Observable<ContractData | null> {
    return this.http.get<ContractData>(API_URLS.getContractData)
      .pipe(
        catchError(() => of(null)),
      );
  }

  authlog(): Observable<any> {
    return this.http.get<any>(API_URLS.authlog);
  }


  changePassword(oldPassword: string, newPassword: string): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(API_URLS.changePassword, {
      old_password: oldPassword,
      new_password: newPassword,
    })
      .pipe(
        catchError(() => of({
          success: false,
          error: 'Серверная ошибка',
        }))
      );
  }

  supportRequest(args: SupportRequestArgs): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(API_URLS.supportRequest, args)
      .pipe(
        catchError(() => of({
          success: false
        }))
      );
  }

}
